import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ClassInfo, classMap } from 'lit/directives/class-map.js';
import './Spinner';

@customElement('media-picker-button')
export class Button extends LitElement {
  public static readonly styles = css`
    :host {
      --button-primary-color: #3f51b5;
      --button-primary-on-color: #fff;

      --button-danger-color: #f84335;
      --button-danger-on-color: #fff;

      display: block;
      font-family: Roboto, sans-serif;
    }

    .button {
      display: flex;
      align-items: center;
      gap: 8px;

      border: none;
      cursor: pointer;
      border-radius: 8px;
      transition: all 0.2s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      box-sizing: border-box;
      text-transform: uppercase;
      min-height: 42px;
      min-width: 42px;
      padding: 4px 12px;
    }

    .button svg,
    .button svg * {
      transition: all 0.3s ease-in;
      overflow: initial;
    }

    .button--primary {
      background-color: var(--button-primary-color);
      color: var(--button-primary-on-color);
    }

    .button--secondary {
      background-color: var(--button-primary-on-color);
      color: var(--button-primary-color);
      border: 1px solid var(--button-primary-color);
    }

    .button--danger,
    .button--delete {
      background-color: var(--button-danger-color);
      color: var(--button-danger-on-color);
    }

    .button--delete:hover svg .trash-lid {
      transform: rotate(-20deg);
      transform-origin: left;
    }

    .button:active {
      scale: 0.95;
    }

    .button:disabled,
    .button--disabled {
      filter: grayscale(0.5);
      cursor: not-allowed;
    }
  `;

  @property({ type: String })
  icon: string = '';

  @property({ type: String })
  label: string = '';

  @property({ type: Boolean })
  loading: boolean = false;

  @property({ type: Object })
  classes: ClassInfo = {};

  @property({ type: String })
  variant: 'primary' | 'secondary' | 'danger' | 'delete' = 'secondary';

  /**
   * Renders the icon or the spinner if loading
   * @returns {TemplateResult}
   */
  renderIcon() {
    if (this.loading) {
      return html`<media-picker-spinner></media-picker-spinner>`;
    }

    return html`${this.icon}`;
  }

  render() {
    return html`
      <button
        class=${classMap({
          button: true,
          ...this.classes,
          'button--primary': this.variant === 'primary',
          'button--secondary': this.variant === 'secondary',
          'button--danger': this.variant === 'danger',
          'button--delete': this.variant === 'delete',
        })}
        ?disabled="${this.loading}"
      >
        ${this.renderIcon()} ${this.label}
      </button>
    `;
  }
}

@customElement('icon-button')
export class IconButton extends Button {
  static readonly styles = css`
    :host {
      display: inline-flex;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 42px;
      height: 42px;

      border-radius: 50%;
      border: none;
      background: transparent;
      color: inherit;

      transition: all 0.2s ease-in-out;
    }

    button svg {
      height: 32px;
      width: 32px;
    }

    button:hover {
      transform: scale(1.1);
      cursor: pointer;
    }

    button:active {
      transform: scale(0.95);
    }
  `;

  /**
   * The icon to be displayed
   */
  @property({ type: String }) icon: string = '';

  render() {
    return html` <button>${this.renderIcon()}</button> `;
  }
}
